import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaChartBar, FaSignOutAlt } from 'react-icons/fa';

const NavBarUser = () => {
  const { user, logout } = useAuth(); // Obtenemos el usuario y la función de logout

  console.log(user)

  if (!user) {
    return null; // Si no hay usuario logueado, no mostramos la navbar
  }

  return (
    <nav
      style={{
        backgroundColor: '#333',
        height: '100%',
        width: '65px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px 0',
        boxShadow: '2px 0 5px rgba(0, 0, 0, 0.1)',
        gap: '30px', // Espaciado entre los íconos aumentado
      }}
    >
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, width: '100%' }}>
              {user.tipoRol === 'consultar_informes' && (
                <>                  
                  <li style={{ marginBottom: '30px', textAlign: 'center' }}>
                    <Link to="/informes" style={{ color: 'white', textDecoration: 'none' }}>
                      <FaChartBar title="Informes" style={{ fontSize: '30px' }} />
                    </Link>
                  </li>
                </>
              )}
              <li style={{ marginTop: 'auto', textAlign: 'center' }}>
                <button
                  onClick={logout}
                  style={{
                    background: 'transparent',
                    color: 'white',
                    border: 'none',
                  }}
                  title="Logout"
                >
                  <FaSignOutAlt style={{ fontSize: '30px' }} />
                </button>
              </li>
            </ul>
          </nav>
        );
      };

export default NavBarUser;
